import React from 'react';
import { IconLongArrowDownRegular } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

interface Props {
  extraBottom?: number;
  goToSizeRecommend: () => void;
}

export const SizeRecommendTooltip: React.FC<React.PropsWithChildren<Props>> = ({ extraBottom, goToSizeRecommend }) => {
  return (
    <DescriptionTooltip
      type='button'
      onClick={goToSizeRecommend}
      className={Typography.BODY_14_SEMIBOLD}
      extraBottom={extraBottom ?? 0}
    >
      <IconLongArrowDownRegular width={24} height={24} v3Color='staticWhite' />
      내게 맞는 사이즈 확인하기
    </DescriptionTooltip>
  );
};

const DescriptionTooltip = styled.button<{ extraBottom: number }>`
  display: flex;
  align-items: center;
  height: 40px;
  padding: 12px 20px 12px 16px;
  border-radius: 20px;
  position: fixed;
  color: ${vars.v3Color.staticWhite};
  background-color: ${vars.v3Color.purple300};
  left: 50%;
  ${({ extraBottom }) =>
    `
    bottom: calc(85px + ${extraBottom}px + env(safe-area-inset-bottom));
    bottom: calc(85px + ${extraBottom}px + constant(safe-area-inset-bottom));
  `}
  transform: translateX(-50%);
  z-index: 999;
  white-space: nowrap;
`;
